import axios from "@/libs/api.request";

export const getUserListByDepartId = departid => {
  return axios.request({
    url: "rbac/getUserListByDepartId",
    data: {
      departid
    },
    csrf: false,
    method: "post"
  });
};

/**
 * 报出员工信息
 */

export const storeUser = data => {
  return axios.request({
    url: "rbac/storeUser",
    data: data,
    csrf: true,
    method: "post"
  });
};

/**
 * 权限控件，选出人员供配置有权限的人
 */
export const getUserList = () => {
  return axios.request({
    url: "rbac/getUserList",
    csrf: false,
    method: "post"
  });
};

export const resetUserPasswdHandler = id => {
  return axios.request({
    url: "rbac/resetUserPasswdHandler",
    data: { id },
    method: "post"
  });
};
export const getUserListBySearch = username => {
  return axios.request({
    url: "rbac/getUserListBySearch",
    data: { username },
    csrf: false,
    method: "post"
  });
};
